import { Box, Text, Title } from '@bottlebooks/gatsby-theme-base';
import React from 'react';
import { Section } from '.';

export default function ErrorSection({ children, error }) {
  const errorStackLines = error?.stack?.split('\n');
  return (
    <Section>
      <Section.Body>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'brand.warningRed',
            backgroundColor: 'brand.lightRed',
            color: 'brand.warningRed',
            padding: 3,
          }}
        >
          <Title variant="small">Error</Title>
          <Text>Message: {error.message}</Text>
          <Box>{children}</Box>
          {errorStackLines?.length > 0 && (
            <Box sx={{ marginTop: 3 }}>
              <Text>Stacktrace</Text>
              {errorStackLines?.map((errorLine, index) => (
                <Box sx={{ paddingLeft: index > 0 ? 3 : 0 }}>
                  <Text>{errorLine}</Text>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Section.Body>
    </Section>
  );
}
